import { Toast, ToastContainer } from 'react-bootstrap';
import { createRoot } from 'react-dom/client';
import { useState, useEffect } from 'react';
import { AiOutlineClose, AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineInfoCircle, AiOutlineWarning } from 'react-icons/ai';

let toastContainer = null;
let toastRoot = null;
let globalToasts = [];

const createToastContainer = () => {
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.top = '20px';
  container.style.right = '20px';
  container.style.zIndex = '9999';
  document.body.appendChild(container);
  return container;
};

const ToastManager = ({ toasts, onRemove }) => {
  const getToastIcon = (type) => {
    switch (type) {
      case 'success':
        return <AiOutlineCheckCircle style={{ color: '#28a745', fontSize: 18, marginRight: 10 }} />;
      case 'error':
        return <AiOutlineCloseCircle style={{ color: '#dc3545', fontSize: 18, marginRight: 10 }} />;
      case 'warning':
        return <AiOutlineWarning style={{ color: '#ffc107', fontSize: 18, marginRight: 10 }} />;
      case 'info':
      default:
        return <AiOutlineInfoCircle style={{ color: '#17a2b8', fontSize: 18, marginRight: 10 }} />;
    }
  };

  return (
    <ToastContainer 
      position="top-end" 
      className="p-3"
      style={{
        width: 'auto',
        minWidth: '300px',
        maxWidth: '400px'
      }}
    >
      {toasts.map((toast) => (
        <Toast
          animation
          key={toast.id}
          onClose={() => onRemove(toast.id)}
          show={true}
          delay={toast.autoClose}
          autohide={toast.autoClose > 0}
         bg='#FFFFFF'
          className="mb-2"
          style={{
            width: '100%',
            minWidth: '300px',
            maxWidth: '400px'
          }}
        >
          <Toast.Body  style={{ display: 'flex', alignItems: 'center', position: 'relative', paddingRight: 32 }}>
            {/* Icon */}
            {getToastIcon(toast.type)}
            {/* Message */}
            <div style={{ flex: 1,fontSize:12 }}>{toast.message}</div>
            {/* Close Button */}
            {toast.closeOnClick && (
            <div>
                <button
                onClick={() => onRemove(toast.id)}
                style={{
                  background: 'none',
                  border: 'none',
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  fontSize: 14,
                  color: '#888',
                  cursor: 'pointer',
                  lineHeight: 1,
                  width:'auto',
                  padding:'0px 5px'
                }}
                aria-label="Close"
              >
                <AiOutlineClose width={20}/>
              </button>
            </div>
            )}
          </Toast.Body>
          {/* Progress Bar */}
          {toast.autoClose > 0 && (
            <div
              style={{
                height: 4,
                width: '100%',
                background: '#e9ecef',
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  height: '100%',
                  width: '100%',
                  background:
                    toast.type === 'success'
                      ? '#28a745'
                      : toast.type === 'error'
                      ? '#dc3545'
                      : toast.type === 'warning'
                      ? '#ffc107'
                      : '#17a2b8',
                  animation: `progressBarAnim ${toast.autoClose}ms linear forwards`,
                }}
              />
            </div>
          )}
        </Toast>
      ))}
    </ToastContainer>
  );
};

const ToastApp = () => {
  const [toasts, setToasts] = useState(globalToasts);

  useEffect(() => {
    setToasts(globalToasts);
  }, [globalToasts]);

  const removeToast = (id) => {
    globalToasts = globalToasts.filter((toast) => toast.id !== id);
    setToasts(globalToasts);
  };

  return <ToastManager toasts={toasts} onRemove={removeToast} />;
};

export const showToast = ({
  type = 'success',
  message = '',
  autoClose = 3000,
  closeOnClick = true,
}) => {
  if (!toastContainer) {
    toastContainer = createToastContainer();
    toastRoot = createRoot(toastContainer);
    toastRoot.render(<ToastApp />);
  }

  const toastId = Date.now();
  const newToast = {
    id: toastId,
    type,
    message,
    autoClose,
    closeOnClick
  };

  globalToasts = [...globalToasts, newToast];
  toastRoot.render(<ToastApp />);

  if (autoClose > 0) {
    setTimeout(() => {
      globalToasts = globalToasts.filter((toast) => toast.id !== toastId);
      toastRoot.render(<ToastApp />);
    }, autoClose);
  }
}; 